module.exports = __webpack_public_path__ + "img/features-split-top-03.13b291cf.png";